import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Tooltip from '@material-ui/core/Tooltip';
import { Fullscreen } from '@material-ui/icons';

import { translate } from 'services/i18nService';
import PeekStore from 'stores/PeekStore';


const FullScreen = ({ onFullScreen, className }) => {
  const checkCallback = useCallback((prop) => prop && typeof prop === 'function', []);
  const { resetPeekStreamData } = PeekStore;

  const handleFullScreen = useCallback(() => {
    if (checkCallback(onFullScreen)) {
      onFullScreen();
      resetPeekStreamData();
    }
  }, [checkCallback, onFullScreen, resetPeekStreamData]);

  return (
    <Tooltip placement="top" title={translate('v2profile.player.controls.fullscreen')}>
      <Fullscreen className={className} id="fullscreen-button" onClick={handleFullScreen} />
    </Tooltip>
  );
};

FullScreen.propTypes = {
  className: PropTypes.string,
  onFullScreen: PropTypes.func,
};

FullScreen.defaultProps = {
  className: '',
  onFullScreen: () => undefined,
};

export default observer(FullScreen);
